import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Container, Link, Arrow } from './index.style'

const Breadcrumb = ({ breadcrumbs }) => (
  <Container>
    {breadcrumbs.map((breadcrumb, index) => (
      <Fragment key={breadcrumb.name}>
        {index !== 0 && <Arrow />}
        <Link to={breadcrumb.url}>{breadcrumb.name}</Link>
      </Fragment>
    ))}
  </Container>
)

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, url: PropTypes.string })
  ).isRequired,
}

export default Breadcrumb
